import type { PilotKpi } from '@/features/pilots/api';

/**
 * The hero banner's headline outcome, derived from the KPI cards that
 * actually carry a real target (`participationRate`, `dailyUsage` — the
 * only two `fetchPilotStatistics` fills a `target` for). `null` means there
 * isn't enough real data yet to call it either way, rather than defaulting
 * to an optimistic or pessimistic guess.
 */
export type PilotOutcome = 'success' | 'partial' | 'atRisk';

export function pilotOutcome(kpis: PilotKpi[]): PilotOutcome | null {
  const withTargets = kpis.filter(
    (kpi): kpi is PilotKpi & { value: number; target: number } =>
      kpi.status === 'ok' && kpi.value !== null && kpi.target !== null,
  );
  if (withTargets.length === 0) return null;

  const met = withTargets.filter((kpi) => kpi.value >= kpi.target);
  if (met.length === withTargets.length) return 'success';
  if (met.length === 0) return 'atRisk';
  return 'partial';
}
